import appApi from '../../../../../api/app-api';
import globalUserPage from '../../../../../stores/global-user-page';

export const addPaymentServiceOperation = async (
  userId: number,
  branchId: number,
  paymentServiceId: number,
  paymentServicePriceId: number,
  setLoading: (loading: boolean) => void,
  closeDialog: () => void,
) => {
  try {
    setLoading(true);

    await appApi.createPaymentServiceAllocation(
      userId,
      branchId,
      paymentServiceId,
      paymentServicePriceId,
    );

    // Refresh user details to get updated payment services
    const updatedUserDetails = await appApi.getUserStudentDetails(userId);
    globalUserPage.studentDetails = updatedUserDetails.data.body;

    closeDialog();
  } catch (error) {
    console.error('Error adding payment service:', error);
    // TODO: Add proper error handling/toast notification
  } finally {
    setLoading(false);
  }
};
